/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   numberize util
 */

import { isNumber } from './isNumber'

export const numberize = (number?: any): string => {
  if (isNumber(number)) {
    const [intPart, floatPart] = Number(number).toString().split('.')
    const numberized = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return floatPart ? `${numberized}.${floatPart}` : numberized
  }
  return number
}
